export interface ServiceStructuredData {
  "@context": "https://schema.org/";
  "@type": "OfferCatalog";
  name: string;
  description: string;
  itemListElement: Array<{
    "@type": "ListItem";
    position: number;
    item: {
      "@type": "Service";
      name: string;
      description: string;
      provider: {
        "@type": "Organization";
        name: "TaskRabbit";
        url: string;
        sameAs: string[];
      };
    };
  }>;
}

interface BuildServiceStructuredDataArgs {
  serviceType: string;
  description: string;
}

export function buildServiceStructuredData({
  serviceType,
  description,
}: BuildServiceStructuredDataArgs): ServiceStructuredData {
  const origin =
    typeof window !== "undefined"
      ? window.location.origin
      : "https://www.taskrabbit.com";

  return {
    "@context": "https://schema.org/",
    "@type": "OfferCatalog",
    name: serviceType,
    description,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "Service",
          name: serviceType,
          description,
          provider: {
            "@type": "Organization",
            name: "TaskRabbit",
            url: origin,
            sameAs: [
              "https://www.facebook.com/Taskrabbit",
              "https://twitter.com/Taskrabbit",
              "https://www.instagram.com/Taskrabbit",
              "https://www.linkedin.com/company/Taskrabbit",
            ],
          },
        },
      },
    ],
  };
}
